import React from 'react'
import { Spin } from 'antd';
import { ErrorServer } from '../../../../components/Errors/ErrorServer';

export const WrapperFiche = ({ error = false, loading = false, children }) => {
    if (error) {
        return <ErrorServer />;
    }

    if (loading) {
        return (
            <div className="w-full h-[calc(100vh-64px)] flex justify-center items-center">
                <Spin size="large" />
            </div>
        );
    }

    return children
}
